import Note from '../../src/legacy/Note.tsx';
export default Note;
